import { SVGProps } from 'react';

const ChartScaleSmallKindLine = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14.0001 14H2M12.6667 5.33331L10.0542 8.12175C9.95514 8.22743 9.90563 8.28027 9.84591 8.30758C9.79319 8.33168 9.73511 8.34162 9.67738 8.33642C9.61197 8.33053 9.54771 8.29716 9.41918 8.23043L7.24761 7.10286C7.11909 7.03613 7.05483 7.00276 6.98942 6.99687C6.93169 6.99167 6.8736 7.00161 6.82089 7.02572C6.76116 7.05303 6.71166 7.10586 6.61264 7.21154L4.00006 9.99998"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ChartScaleSmallKindLine;
